import SupportTicketsPage from "./SupportTicketsPage";

export default SupportTicketsPage;
